import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import {cartItemInterface} from "../../../shoppingCart/cartItemInterface";
import {IS_PRODUCT_JOURNEY} from "../../../../config";
import {
  setLookActiveCategory,
  setLookPageOpened,
  setLookStylePopup
} from "../../../../actions/lookFunctions";
import WithZoomToFeature from "../../hocs/withZoomToFeature";
import LookCanvasContext from "../../lookCanvasContext";
import {changeCartFeature} from "../../../../actions/actionFunctions";
import {setCartItemEditFeature} from "../../../../actions/shoppingCartFunctions";
import {ROUTES} from "../../../../routes";

const GroheCartItemActions = (props) => {

  const {cartItem, intl, changeCartFeature, setLookPageOpened, setLookActiveCategory, setCartItemEditFeature, history,
    shopPageOpened} = props;

  const toggleCartItemRemoved = () => {
    cartItem.isRemoved = !cartItem.isRemoved;
    changeCartFeature(cartItem);
  }

  const changeItemButtonCLick = (zoomToFeatureGroup) => {
    if (cartItem.isRemoved) {
      return false
    }
    if (shopPageOpened) {
      toggleCartItemRemoved();
      history.push(`${ROUTES.shop}/${cartItem.partId}/`);
      return false
    }
    setLookPageOpened("");
    zoomToFeatureGroup(cartItem.partId, cartItem.cartFeature);
    setTimeout(() => {
      setLookActiveCategory(cartItem.partId);
      setCartItemEditFeature(cartItem);
    }, 300)
  }

  return (
    <div className="ll-feature__actions">
      {IS_PRODUCT_JOURNEY ? (
        <LookCanvasContext.Consumer>
          {(imageCanvas) => (
            <WithZoomToFeature imageCanvas={imageCanvas}>
              {(zoomToFeatureGroup) => (
                <IconButton aria-label={intl.formatMessage({id:"iconButton.delete"})}
                            className="look-icon look-icon--small ll-feature__actions-button"
                            onClick={() => changeItemButtonCLick(zoomToFeatureGroup)}>
                  <EditIcon/>
                </IconButton>
              )}
            </WithZoomToFeature>
          )}
        </LookCanvasContext.Consumer>
      ) : null}
      <IconButton aria-label={intl.formatMessage({id:"iconButton.delete"})}
                  className="look-icon look-icon--small"
                  onClick={toggleCartItemRemoved}>
        {cartItem.isRemoved ? <AddCircleOutlineIcon/> : <DeleteForeverIcon/>}
      </IconButton>
    </div>
  )
};

GroheCartItemActions.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
  isRemoved: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {shopPageOpened} = store.shopState;
  return {
    shopPageOpened
  };
};

const mapDispatchToProps = {
  setLookStylePopup,
  setLookPageOpened,
  setLookActiveCategory,
  changeCartFeature,
  setCartItemEditFeature,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartItemActions)
  )
)
